module.exports = __webpack_public_path__ + "media/images/webpage/pages/about/sp-cover-a3ae934660374f871d17646002f924c9.webp";